export const IEEE_PRIMARY_COLOR = "#185e9c";
export const IEEE_SECONDARY_COLOR = "#FF8D3A";

export function isPreXtreme(contest) {
    return contest.name.startsWith("pre");
}
